import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ProdutoService} from "../../../services/produto.service";

@Component({
  selector: 'app-produto-preco',
  templateUrl: './produto-preco.component.html',
  styleUrls: ['./produto-preco.component.scss']
})
export class ProdutoPrecoComponent implements OnInit,  OnChanges  {
  @Input() produto: any = {}
  @Input() catalogo: any = {};
  @Input() empresa: any = {};
  @Input() podeEditar: any = {};
  precoPorEmpresa: boolean;
  atualizarPreco: boolean
  salvando: boolean
  precoExibir: any;
  precoEditado: any;
  novoPrecoExibir: any;
  constructor( private produtoService: ProdutoService) { }

  ngOnInit(): void {
    this.produto.precoTela = this.produto.novoPreco ? this.produto.novoPreco : this.produto.preco;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.precoPorEmpresa = this.catalogo.precoPorEmpresa;
    const produtoNaEmpresa = this.produto.produtoNaEmpresa;
    const opcaoNaEmpresa = this.produto.opcaoNaEmpresa
    const opcaoNaEmpresaExiste = this.precoPorEmpresa && opcaoNaEmpresa;
    const produtoNaEmpresaExiste = this.precoPorEmpresa && produtoNaEmpresa;

    let diferencaPrecoMinimo = 0

    let precoNaEmpresa = produtoNaEmpresaExiste && produtoNaEmpresa.preco ? produtoNaEmpresa.preco : this.produto.preco;
    let valorAdicionalNaEmpresa = opcaoNaEmpresaExiste &&  opcaoNaEmpresa.valor ? opcaoNaEmpresa.valor : this.produto.valor;

    if(!this.produto.valorMinimo){
      this.precoExibir = precoNaEmpresa;

      if(!this.precoExibir && valorAdicionalNaEmpresa != null) //opção de adicional
         this.precoExibir = valorAdicionalNaEmpresa;

    } else{
      this.precoExibir = this.produto.valorMinimo;

      diferencaPrecoMinimo = this.produto.valorMinimo - (precoNaEmpresa ? precoNaEmpresa : valorAdicionalNaEmpresa);
    }

    this.novoPrecoExibir = produtoNaEmpresaExiste && produtoNaEmpresa.novoPreco ? produtoNaEmpresa.novoPreco : this.produto.novoPreco;

    this.novoPrecoExibir += diferencaPrecoMinimo;


    this.produto.precoTela = this.novoPrecoExibir != null ? this.novoPrecoExibir : this.precoExibir;
  }


  obtenhaFormatoPreco(){
    if(!this.produto.tipoDeVenda || this.produto.tipoDeVenda !== 'Peso')
      return '$0.00'

    return String(`$ 0.00/ kg`);
  }

  salvarPreco(){

    if(this.precoExibir !== this.precoEditado){
      if(this.salvando) return;

      this.salvando = true;
      this.produtoService.salvePrecoProduto(this.catalogo, this.empresa, this.produto, this.precoEditado).then( resposta => {
        this.precoExibir  = this.precoEditado
        this.salvando = false;
        this.cancelarPreco();
      }).catch((err) => {
        this.salvando = false;
         alert(err)
      })

    } else {
      this.cancelarPreco()
    }
  }

  editarPreco() {
    this.precoEditado = this.precoExibir;
    this.atualizarPreco = true;
  }

  cancelarPreco(){
    this.atualizarPreco = false;
  }
}
